import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';

export const hasToBookTriage: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);


  return store.select(AuthSelectors.getCurrentLogged).pipe(
    map((accountData) => {
        if (accountData?.hasToBookTriage) {
          return router.parseUrl('/fill-content/book-triage');
        }
        return true;
      }
    ));
};